import { DropdownReducerActionTypes } from '../types/DropdownReducerActionTypes';
/**
 * An action dispatchable to DropdownReducer.
 * Fire when we have an array of dropdown options to render to the screen. This will populate the dropdown menu
 *
 * @param {DropdownOption[]} dropdownOptions
 * @returns {DropdownReducerAction}
 */
export var searchResolvedAction = function (dropdownOptions) { return ({
    type: DropdownReducerActionTypes.SearchResolved,
    payload: {
        dropdownOptions: dropdownOptions,
    },
}); };
//# sourceMappingURL=searchResolvedAction.js.map